import { JetView } from "webix-jet"; // Importing JetView from webix-jet framework
import { allpayments } from "models/allpayments"; // Importing allpayments model
import { devConfig, profile } from "config/config"; // Importing configuration settings

/**
 * Class representing the TableConsolidatedIncomeView.
 * @extends JetView
 */
export default class TableConsolidatedIncomeView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a percentage value.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + "%"; // Formatting value as percentage
        }

        // Extending the summTreeColumn filter to customize its behavior
        webix.ui.datafilter.summTreeColumn = webix.extend({
            /**
             * Refreshes the filter display with the calculated sum.
             * @param {Object} master - The master data view.
             * @param {Object} node - The node to refresh.
             * @param {Object} value - The value object containing columnId.
             */
            refresh: function (master, node, value) {
                var result = 0; // Variable to hold the sum result
                var resultFormat = 0; // Variable to hold the formatted result
                master.data.each(function (obj) {
                    if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                });
                // Formatting the result based on the columnId
                if (value.columnId === 'bettingName') {
                    resultFormat = webix.i18n.intFormat(result);
                } else {
                    if (value.columnId === 'GgrPorc') {
                        resultFormat = webix.i18n.numberFormat(result) + "%";
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                }
                node.firstChild.innerHTML = resultFormat; // Updating the node with the formatted result
            }
        }, webix.ui.datafilter.summColumn);

        return {
            rows: [{
                cols: [
                    {
                        view: "treetable", // Defining a tree table view
                        id: "treetable", // Unique identifier for the tree table
                        css: "webix_header_border webix_data_border webix_footer_border informeGerencial", // CSS classes for styling
                        scroll: "xy", // Enabling both horizontal and vertical scrolling
                        bready: function () {
                            this.openAll(); // Expanding all rows when ready
                        },
                        columns: [
                            {
                                id: "date", // Column ID
                                header: _("Fecha"), // Column header with localization
                                width: 150, // Column width
                                template: function (obj, common) {
                                    if (obj.$group) {
                                        return common.treetable(obj, common) + (self.dateRange || "TOTAL");
                                    }
                                    return obj.date;
                                }
                            },
                            {
                                id: "bettingName",
                                header: _("Apuestas"),
                                format: webix.i18n.priceFormat, // Formatting function for price values
                                width: 150
                            },
                            {
                                id: "sportBetting",
                                header: _("Apuestas Deportivas"),
                                format: webix.i18n.priceFormat, // Formatting function for price values
                                width: 150
                            },
                            {
                                id: "casinoBetting",
                                header: _("Apuestas Casino"),
                                format: webix.i18n.priceFormat, // Formatting function for price values
                                width: 150
                            },
                            {
                                id: "quantityBetting",
                                header: _("Cantidad Apuestas"),
                                format: webix.i18n.priceFormat, // Formatting function for price values
                                width: 150
                            },
                            {
                                id: "quantitySportBetting",
                                header: _("Cantidad Apuestas Deportivas"),
                                format: webix.i18n.priceFormat, // Formatting function for price values
                                width: 150
                            },
                            {
                                id: "quantityCasinoBetting",
                                header: _("Cantidad Apuestas Casino"),
                                format: webix.i18n.priceFormat, // Formatting function for price values
                                width: 150
                            },
                            {
                                id: "replay",
                                header: _("Rejuego"),
                                format: webix.i18n.priceFormat, // Formatting function for price values
                                width: 150
                            },
                            {
                                id: "betsPlusPlay",
                                header: _("Apuestas + Rejuego"),
                                format: webix.i18n.priceFormat, // Formatting function for price values
                                width: 150
                            },
                            {
                                id: "betPlusPlaySports",
                                header: _("Apuestas + Rejuego Deportivas"),
                                format: webix.i18n.priceFormat,
                                width: 150
                            },
                            {
                                id: "betPlusPlayCasino",
                                header: _("Apuestas + Rejuego Casino"),
                                format: webix.i18n.priceFormat,
                                width: 150
                            },
                            {
                                id: "sportPrizes",
                                header: _("Premios Deportivas"),
                                format: webix.i18n.priceFormat,
                                width: 150
                            },
                            {
                                id: "casinoPrizes",
                                header: _("Premios Casino"),
                                format: webix.i18n.priceFormat,
                                width: 150
                            },
                            {
                                id: "prizePaid",
                                header: _("Premios Pagados"),
                                format: webix.i18n.priceFormat,
                                width: 150
                            },
                            {
                                id: "sportPrizePaid",
                                header: _("Premios Pagados Deportivas"),
                                format: webix.i18n.priceFormat,
                                width: 150
                            },
                            {
                                id: "casinoPrizePaid",
                                header: _("Premios Pagados Casino"),
                                format: webix.i18n.priceFormat,
                                width: 150
                            },
                        ],
                        on: {
                            /**
                             * Event triggered before loading data.
                             */
                            onBeforeLoad: function () {
                                this.showOverlay("<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>"); // Show loading overlay
                            },
                            /**
                             * Event triggered after data is loaded.
                             */
                            onAfterLoad: function () {
                                this.hideOverlay(); // Hide loading overlay
                            }
                        },
                        /**
                         * Event triggered when the grid is ready.
                         */
                        ready: function () {
                            if (!this.count()) {
                                webix.extend(this, webix.OverlayBox); // Extending with overlay functionality
                                this.showOverlay("<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + "</div>"); // Show no data overlay
                            }
                        },
                        autowidth: false, // Disable automatic width adjustment
                        math: true, // Enable mathematical operations
                        datafetch: 10, // Number of records to fetch at a time
                        pager: "pagerA" // Pager ID for pagination
                    }
                ]
            }]
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid instance to initialize.
     */
    init(grid) {
        grid = $$('treetable'); // Getting the tree table instance
        var url = devConfig.geturlApi() + "es/Report/ConsolidatedRevenueReport"; // API endpoint for fetching data
        grid.attachEvent("onAfterLoad", function () {
            $$("treetable").data.group({ // Grouping data after load
                by: function () {
                    return "TOTAL";
                },
                map: {
                    bettingName: ["bettingName", "sum"],// Summing tickets
                    sportBetting: ["sportBetting", "sum"],            
                    casinoBetting: ["casinoBetting", "sum"],            
                    quantityBetting: ["quantityBetting", "sum"],        
                    quantitySportBetting: ["quantitySportBetting", "sum"], 
                    quantityCasinoBetting: ["quantityCasinoBetting", "sum"], 
                    replay: ["replay", "sum"], // Summing total jackpot prize
                    betsPlusPlay: ["betsPlusPlay", "sum"],// Summing betsPlusPlay
                    betPlusPlaySports: ["betPlusPlaySports", "sum"],  // Summing live bets
                    betPlusPlayCasino: ["betPlusPlayCasino", "sum"],// Summing prematch bets
                    sportPrizes: ["sportPrizes", "sum"], // Summing mixed bets
                    casinoPrizes: ["casinoPrizes", "sum"],// Summing mixed bets
                    prizePaid: ["prizePaid", "sum"],  // Summing horse racing bets
                    sportPrizePaid: ["sportPrizePaid", "sum"],          
                    casinoPrizePaid: ["casinoPrizePaid", "sum"],        
                }
            });
        });

        // Event listener for filtering data
        this.on(this.app, "informeGerencial:filter", filterData => {
            var object = Object.entries(filterData); // Converting filter data to entries
            var string1 = ""; // Query string for API request
            for (var i = 0; i < object.length; i++) {
                if ((typeof object[i][1] !== "object") && (object[i][1] !== "")) {
                    if (object[i][0] == "Datepicker") {
                        var date = object[i][1].split(" - "); // Splitting date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Adding start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Adding end date to query
                    } else {
                        if (object[i][0] != "Sort" && object[i][0] != "Dir" && object[i][0] != "Date") {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Adding other filters to query
                        } else {
                            if (object[i][0] == "Date") {
                                var date = object[i][1].replace(" 00:00:00", ""); // Formatting date
                                string1 = string1 + '&dateFrom=' + date; // Adding date to query
                                string1 = string1 + '&dateTo=' + date; // Adding date to query
                            }
                        }
                    }
                } else {
                    if ((typeof object[i][1] === "object")) {
                        var object2 = Object.entries(object[i][1]); // Converting nested filter data to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === "start") {
                                    var d = new Date(object2[j][1]); // Creating date object for start date
                                    var dateFrom = "dateFrom=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2); // Formatting start date
                                    string1 = string1 + '&' + dateFrom; // Adding start date to query
                                } else {
                                    if (object2[j][0] === "end") {
                                        var d = new Date(object2[j][1]); // Creating date object for end date
                                        var dateTo = "dateTo=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2); // Formatting end date
                                        string1 = string1 + '&' + dateTo; // Adding end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clearing the grid data
            $$("consultDesk").define("disabled", true); // Disabling the consult desk during loading
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1)
                .then((response) => {
                    const data = response.json().Data;

                    grid.clearAll(); // importante
                    grid.parse(data);

                    $$("consultDesk").define("disabled", false); // Enabling consult desk after loading
                }).catch((e) => {
                    $$("consultDesk").define("disabled", false); // Enabling consult desk on error
                });
            $$("filterPopup").hide(); // Hiding the filter popup
        });

        // Event listener for item click in the grid
        grid.attachEvent("onItemClick", function (id, e, node) {
            var item = this.getItem(id); // Getting the clicked item
            this.$scope.app.callEvent("user:id", [item.Id]); // Triggering user ID event
        });

        // Event listener for player selection
        this.on(this.app, "player:select", Id => {
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id); // Loading grid data based on selected player
        });
    }
}

// FILE DOCUMENTED
